'use client';
import { JumboThemeHeaderContextType } from 'themes/jumbo/@jumbo/types';
import { createTheme } from '@mui/material';
import React from 'react';

const defaultContextValue: JumboThemeHeaderContextType = {
  headerTheme: createTheme({}),
  setHeaderTheme: () => null,
};

const JumboThemeHeaderContext = React.createContext(defaultContextValue);

export { JumboThemeHeaderContext };
